import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError, getApiClient } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { Discount } from '@cast/types';

import { getDiscountsQueryKey } from './useDiscountsQuery';

export const useUpdateDiscountMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (discount: Discount) => {
      return getApiClient().discounts.updateDiscount({
        discountId: discount.id!,
        discount,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getDiscountsQueryKey() });
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
